













































import Vue from 'vue'
import ExtranetUi from '../components/extranetui/index'
export default Vue.extend({
  components: {
    ExtranetUi
  },
  data() {
    return {
      maxDeviceCount:1,
      removeFeature: true,
      editFeature: true,
    }
  },
  computed: {
  },
  mounted() {
  },
  created() {
  },
  destroyed() {
  },
  methods: {
    changeRemove(){
      this.removeFeature=!this.removeFeature
    },
    getData(){
      const ui = this.$refs.extranetui;
      if(ui){
        const data = ui.getExtranetData();
        alert(JSON.stringify(data));
      }
    },
    getIpList(){
      const ui = this.$refs.extranetui;
      if(ui){
        const data = ui.getIpList();
        alert(JSON.stringify(data));
      }
    },
    setData(){
      const data={
        pc:{
          virtualIp: '10.8.6.7'
        },
        gateway:{
          code:'2206010020005FFDD',
          virtualIp: undefined,
          networkDataList: [
            {
              name:'eth0',
              ip:'192.168.10.10'
            },
            {
              name:'eth1',
              ip:'192.168.11.10'
            }
          ]
        },
        deviceDataList:[
          {
            name:'cnc1',
            virtualIp:'10.8.6.140',
            physicalIp:'192.168.10.20',
            ipClone: false,
            linkGatewayIp:'192.168.10.10'
          },
          {
            name:'cnc2',
            virtualIp:'10.8.6.141',
            physicalIp:'192.168.11.21',
            ipClone: true,
            linkGatewayIp:'192.168.11.10'
          }
        ]
      };
      const ui = this.$refs.extranetui;
      ui.updateExtranetData(data);
    }
  }
})
